'use client';

import { usePathname } from 'next/navigation';
import LayoutWrapper from './layout_middle';
import MobilePreviewShell from '@/components/mobile/mobile-preview-shell';

export default function LayoutRouter({ routeContent, sharedOverlays }) {
    const path = usePathname();
    const runtimePath = path || (typeof window !== 'undefined' ? window.location.pathname : '');

    if (runtimePath.startsWith('/mobile-page')) {
        return <MobilePreviewShell>{routeContent}</MobilePreviewShell>;
    }

    return <LayoutWrapper runtimePath={runtimePath} overlays={sharedOverlays}>
        {routeContent}
    </LayoutWrapper>;
}